// Libs
import { Checkbox, Typography } from "@material-ui/core";
import { useObserver } from "@shoothill/core";
// Models
import { HomeOwnerStatusEnum } from "Globals/Models/HomeOwnerStatusEnum";
// App
import { Stores, StoresContext } from "Globals/Stores";
import { CustomInput } from "Globals/Styles/AppStyling";
import { Row } from "Globals/Styles/LayoutStyles";
import ApplicantViewModel from "Globals/ViewModels/ApplicantViewModel";
// ViewModels
import ApplicationFormViewModel from "Globals/ViewModels/ApplicationFormViewModel";
import { CheckboxCheckedSVG } from "Globals/Views/IconSVGs/CheckboxCheckedSVG";
import { CheckboxSVG } from "Globals/Views/IconSVGs/CheckboxSVG";
import React, { useContext, useState } from "react";
import { RemovedNameFromMortgage } from "./RemovedNameFromMortgage";
import { RemovingNameFromMortgage } from "./RemovingNameFromMortgage";
import { SellingYourHome } from "./SellingYourHome";
import { SoldYourHome } from "./SoldYourHome";

interface IProps {
    applicant: ApplicantViewModel;
    applicationFormViewModel: ApplicationFormViewModel;
}

export const CurrentPropertyDetailsView: React.FC<IProps> = (props: IProps) => {
    const storesContext = useContext<Stores>(StoresContext);
    const [viewModel] = useState(props.applicant.currentPropertyDetailsViewModel);

    const isPrimaryApplicant = (): boolean => {
        let applicants = props.applicationFormViewModel.applicantViewModels;
        let firstApplicant = applicants.find((a) => a.model.primaryApplicant);
        if (firstApplicant) {
            if (props.applicant.model.id == firstApplicant.model.id) return true;
        }
        return false;
    };

    const getPrimaryApplicant = (): ApplicantViewModel | undefined => {
        let applicants = props.applicationFormViewModel.applicantViewModels;
        let primaryApplicant = applicants.find((a) => a.model && a.model.primaryApplicant);
        return primaryApplicant;
    };

    return useObserver(() => (
        <div onMouseDown={() => viewModel.restartTimer()} onKeyUp={() => viewModel.restartTimer()}>
            {viewModel.DevTool_ShowCanProceed && <h5 style={{ color: "red" }}>Can Proceed: {viewModel.canProceed ? "Yes" : "No"}</h5>}
            <div>
                <Row>
                    <CustomInput
                        type="select"
                        style={{ minWidth: "500px" }}
                        placeHolder={"Please select"}
                        label="Which one best describes your current / previous home owner status?"
                        viewModel={viewModel}
                        fieldName="homeOwnerStatusId"
                        selectItems={storesContext.Domain.HomeOwnerStatusStore.getOptions}
                        inputProps={{
                            disabled: props.applicationFormViewModel.model.isSubmitted,
                        }}
                    />
                </Row>
                {storesContext.Domain.HomeOwnerStatusStore.getEnumFromId(viewModel.model.homeOwnerStatusId) === HomeOwnerStatusEnum.Selling && (
                    <SellingYourHome viewModel={viewModel} applicationFormViewModel={props.applicationFormViewModel} />
                )}
                {storesContext.Domain.HomeOwnerStatusStore.getEnumFromId(viewModel.model.homeOwnerStatusId) === HomeOwnerStatusEnum.Sold && (
                    <SoldYourHome viewModel={viewModel} applicationFormViewModel={props.applicationFormViewModel} />
                )}
                {storesContext.Domain.HomeOwnerStatusStore.getEnumFromId(viewModel.model.homeOwnerStatusId) === HomeOwnerStatusEnum.RemovingNameFromMortgage && (
                    <RemovingNameFromMortgage viewModel={viewModel} applicationFormViewModel={props.applicationFormViewModel} />
                )}
                {storesContext.Domain.HomeOwnerStatusStore.getEnumFromId(viewModel.model.homeOwnerStatusId) === HomeOwnerStatusEnum.RemovedNameFromMortgage && (
                    <RemovedNameFromMortgage viewModel={viewModel} applicationFormViewModel={props.applicationFormViewModel} />
                )}
            </div>
        </div>
    ));
};
